import {
  Button,
  Container,
  Modal,
  SegmentedControl,
  Text,
  useMantineTheme,
} from "@mantine/core";
import React, { useContext, useEffect, useState } from "react";
import { ListProfilesContext } from "../context/ListProfilesContext";
import ComponentInputSearch from "../../components/GlobalComponent/ComponentInputSearch";
import { AppSettingsContext } from "../context/AppSettingsContext";

const ModalStatus = ({show, setShowModal, setUuidProfile, handleStart}) => {
  const theme = useMantineTheme();
  const [profileModes, setProfileModes] = useState(['Cloud', 'Local'])
  const { userCharge } = useContext(AppSettingsContext)
  const { listProfile, valueChoose, setValueChoose, setSearch, setIsCloud, isCloud } = useContext(ListProfilesContext)
  const handleSetValue = (item) => {
    if (typeof item === 'string') {
        setValueChoose(item)
        setSearch(item)
    } else if (typeof item === 'object') {
        setValueChoose(item.label)
    }
    let browserName = listProfile.find(ele => ele.value === item?.value)
    setUuidProfile({uuid : item?.value, browser_name: browserName?.label})
  }

  useEffect(() => {
    if (userCharge?.current) {
      const result = []
      if (userCharge?.current?.profile) {
        result.push("Cloud")
      } else {
        setIsCloud(false)
      }
      if (userCharge?.current?.profile_local && userCharge?.current?.roles?.includes("active_local")) {
        result.push("Local")
      }
      setProfileModes(result)
    }
  }, [userCharge.current])

  const handleClose = () => {
      setShowModal(false);
  }

  return (
    <Modal
      zIndex={1000}
      opened={show}
      onClose={handleClose}
      overlayColor={
        theme.colorScheme === "dark"
          ? theme.colors.dark[9]
          : theme.colors.gray[2]
      }
      title={
        <Text fw={500} fz="xl">
          Run Node
        </Text>
      }
      overlayOpacity={0.55}
      overlayBlur={0.5}
      size="lg"
    >
      <Container>
        <div style={{ marginBottom: "12px" }}>
          {
            !!userCharge.current?.profile_local && (
              <SegmentedControl
                style={{ marginBottom: 12 }}
                data={profileModes}
                value={ isCloud ? 'Cloud' : 'Local' }
                onChange={(value) => setIsCloud(value === 'Cloud')}
              />
            )
          }
          <ComponentInputSearch
            listProfile={profileModes?.length ? listProfile : []}
            placeholder="Choose a profile"
            label="Run on uuid"
            withAsterisk={true}
            handleData={(e) => handleSetValue(e)}
            dataState={valueChoose}
            setUuidProfile={setUuidProfile}
          />
          <div style={{ textAlign: "end", marginTop: "20px" }}>
            <Button onClick={handleStart} variant="outline" color="teal">
              Start
            </Button>
          </div>
        </div>
      </Container>
    </Modal>
  );
};
export default ModalStatus;
